module.exports = __webpack_public_path__ + "media/facial-recognition/front-on-6bfd967b.svg";